import {
  imageWidget,
  embedWidget,
  videoWidget,
  triggerWidget,
  commentWidget,
  questionWidget,
  downloadFileWidget,
  multipleChoiceQuestionWidget,
} from "../../constants/widget";

// TODO: Could consolidate imports?
import EmbedWidget from "./EmbedWidget";
import ImageWidget from "./ImageWidget";
import VideoWidget from "./VideoWidget";
import TriggerWidget from "./TriggerWidget";
import CommentWidget from "./CommentWidget";
import QuestionWidget from "./QuestionWidget";
import DownloadFileWidget from "./DownloadFileWidget";
import MultipleChoiceQuestionWidget from "./MultipleChoiceQuestionWidget";

function Widget(props) {
  function renderWidget() {
    switch (props.lesson_module_name) {
      case imageWidget:
        return <ImageWidget {...props} />
      case embedWidget:
        return <EmbedWidget {...props} />
      case videoWidget:
        return <VideoWidget {...props} />
      case triggerWidget:
        return <TriggerWidget {...props} />
      case commentWidget:
        return <CommentWidget {...props} />
      case questionWidget:
        return <QuestionWidget {...props} />
      case downloadFileWidget:
        return <DownloadFileWidget {...props} />
      case multipleChoiceQuestionWidget:
        return <MultipleChoiceQuestionWidget {...props} />
      default:
        return <CommentWidget {...props} />;
    }
  }

  const classNames = {
    LessonEmbedModule: "EmbedWidget",
    LessonImageModule: "ImageWidget",
    LessonVideoModule: "VideoWidget",
    LessonTriggerModule: "MultiChoiceWidget",
    LessonCommentModule: "CommentWidget",
    LessonQuestionModule: "QuestionWidget",
    LessonDownloadFileModule: "DownloadFileWidget",
    LessonMultipleChoiceQuestionModule: "MultiChoiceWidget",
    LessonFillInTheBlankModule: "FillInTheBlankWidget",
  }
  return (
    <div
      className={`Widget ${classNames[props.lesson_module_name]}`}
      data-widget-position={props.position - 1}
    >
      {renderWidget()}
    </div>
  )
}

export { Widget };
